var _style, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruhailFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @keyframes pulse{0%,100%{opacity:0.75;}50%{opacity:1;}}\n        .car{animation:pulse 2.5s ease-in-out infinite;}\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#00C2FF",
    opacity: 0.85,
    transform: "rotate(15 8 9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 8,
    height: 26,
    rx: 2,
    fill: "#8B5CF6",
    opacity: 0.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#06B6D4",
    opacity: 0.85,
    transform: "rotate(-15 24 9)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "car",
    transform: "translate(2, 23) scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2,8 L 4,4 L 8,2 L 16,2 L 20,4 L 22,8 L 22,10 L 2,10 Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 2,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 2,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 0.8,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 0.8,
    fill: "#00C2FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruhailFavicon);
export default __webpack_public_path__ + "static/media/truhail_favicon.ba24a1fd845582812459bc30277a1697.svg";
export { ForwardRef as ReactComponent };